<div class="page-container aml-detail-container container pt-2">
  <h1 class="header col-12 mb-1"> AML {{ amlType }} Details </h1>
  <div class="actions-container mb-3">
    <button
      type="button"
      mat-button
      color="primary"
      (click)="nav('aml-monitor')"
    >
      <mat-icon>arrow_back_ios</mat-icon> Back to AML Monitor
    </button>
  </div>
  @if (!loading) {
    <div class="trade-info-container info-card mb-4 w-100 p-0">
      <div class="card-header">
        <span class="card-title-container">
          Alert ID:
          <span class="card-title mb-0 ms-2">
            {{ amlDetail.AlertID }}
          </span>
        </span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="amlDetail.ReviewStatus"
              [recordType]="'aml'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="card-info row">
        @for (amlInfo of amlInfoKey; track amlInfo.label) {
          @if (
            (amlDetail && amlDetail[amlInfo.varName]) ||
            (amlInfo.key && amlInfo.key[amlDetail[amlInfo.varName]])
          ) {
            <app-card-infopoint
              class="col-sm-3 col-12"
              [datapoint]="amlInfo"
              [dataset]="amlDetail"
              [disableDecryption]="amlType === 'Client'"
            />
          }
        }
      </div>
    </div>

    @if (amlDetail?.Details?.bridges) {
      <div class="alerts-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Alerts </span>
        </div>
        <div class="card-info row">
          <div class="alerts">
            <span class="primary-alert-indicator"> Alert for Review </span>

            <app-reason-text
              class="col-6"
              [data]="primaryAlerts"
              [defaultView]="'list'"
            />
          </div>
        </div>

        @if (otherAlerts.length > 0) {
          <div class="card-header secondary">
            <span class="card-title mb-0">
              Other Triggered Alerts

              <button
                type="button"
                mat-stroked-button
                class="ms-2"
                (click)="toggleMoreAlerts()"
              >
                @if (showOtherAlerts) {
                  Click to Hide
                } @else {
                  Click to View
                }
              </button>
            </span>
          </div>
          <div
            class="card-info row secondary-alerts {{
              showOtherAlerts ? 'show' : 'hide'
            }}"
          >
            <span class="secondary-alert-info">
              The alerts below are for context only and will be reviewed
              separately
            </span>
            <div class="alerts">
              <app-reason-text
                class="col-6"
                [data]="otherAlerts"
                [defaultView]="'list'"
                [hideExplanations]="true"
              />
            </div>
          </div>
        }
      </div>
    }

    <div class="multi-table-container">
      @if (amlDetail?.Details?.AccountInfoDisplay) {
        <app-records-accordion
          class="w-50"
          [title]="'Account Information'"
          [infoKey]="accountKey"
          [recordDetail]="amlDetail.Details.AccountInfoDisplay"
          [panelVar]="'AccountNumDisplay'"
          [defaultOpen]="true"
        />
      }

      @if (amlDetail.Details.ClientInfoDisplay) {
        <app-records-accordion
          class="{{ amlDetail.Details?.AccountInfoDisplay ? 'w-50' : 'w-100' }}"
          [title]="'Client Information'"
          [infoKey]="suitabilityKey"
          [recordDetail]="amlDetail.Details.ClientInfoDisplay"
          [panelVar]="'FullName'"
          [defaultOpen]="true"
        />
      }
    </div>

    @if (amlDetail?.Details?.AMLMetrics) {
      <div class="key-metrics-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Key Metrics </span>
        </div>
        <div class="card-info row">
          @for (keyMetric of keyMetricsKey; track keyMetric.label) {
            @if (
              amlDetail.Details.AMLMetrics[keyMetric.varName] ||
              amlDetail.Details.AMLMetrics[keyMetric.varName] === 0
            ) {
              <app-card-infopoint
                class="col-sm-3 col-12"
                [datapoint]="keyMetric"
                [dataset]="amlDetail.Details.AMLMetrics"
              />
            }
          }
        </div>
      </div>
    }

    <div class="info-card mb-4">
      <div class="card-header">
        <span class="card-title mb-0">Actions</span>

        @if (!rights.includes('PostTradeReadOnly')) {
          <span>
            <app-approval-menu
              [recordStatus]="amlDetail.ReviewStatus"
              [recordType]="'aml'"
              (toggleStatus)="toggleReviewed($event)"
            />
          </span>
        }
      </div>
      <div class="actions-card">
        <div class="custom-tabs">
          <mat-tab-group [selectedIndex]="selectedActionTab">
            <mat-tab label="Notes & Attachments">
              <app-attachments-widget
                [tradeId]="amlId"
                [tradeDetail]="amlDetail"
                [widgetType]="'aml'"
                [readOnly]="rights.includes('PostTradeReadOnly')"
              />
            </mat-tab>

            <mat-tab label="Review Status History">
              <app-expanding-table
                [dataset]="amlDetail.AMLAlertApprovalHistory"
                [evalKey]="amlReviewKey"
              />
            </mat-tab>

            @if (rights.includes('CM')) {
              <mat-tab label="Case History">
                @if (!rights.includes('PostTradeReadOnly')) {
                  <div class="mb-2 pt-2 initiate-case-container">
                    <button
                      type="button"
                      mat-raised-button
                      color="primary"
                      class="w-50"
                      (click)="initiateCase()"
                    >
                      <mat-icon>medical_services</mat-icon> Initiate Case
                    </button>
                  </div>
                }

                <app-expanding-table
                  [dataset]="caseHistory"
                  [evalKey]="caseHistoryKey"
                  [actionColumn]="{
                    link: 'case-management/case-manager/',
                    selector: 'CRID',
                    tooltip: 'Review Case',
                    icon: 'rate_review',
                    external: true,
                  }"
                />
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      </div>
    </div>

    @if (amlDetail?.Details?.DisplayFX?.ShowTradeHistory) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Transaction History </span>
        </div>
        <app-expanding-table
          [dataset]="amlDetail.Details?.TradeHistoryFiltered"
          [evalKey]="tradeHistoryKey"
          [actionColumn]="{
            link: 'trade-review/',
            selector: 'TradeID',
            tooltip: 'View Transaction',
            icon: 'launch',
            external: true,
          }"
        />
      </div>
    }

    @if (amlDetail?.Details?.DisplayFX?.ShowMoneyMovementHistory) {
      <div class="mutual-funds-container info-card mb-4">
        <div class="card-header">
          <span class="card-title mb-0"> Money Movement History </span>
        </div>
        <app-expanding-table
          [dataset]="amlDetail.Details?.MoneyMovementHistory"
          [evalKey]="moneyMovementKey"
        />
      </div>
    }

    <app-holdings-card [chartDetails]="amlDetail.Details" />
  }

  <ngx-loading [show]="loading" />
</div>
